package kz.dentalcrm.app.screens.main.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface MainViewEvent : ViewEvent {
    data class OnTabSelected(val tabIndex: Int) : MainViewEvent
}
